<template>
    <div :id="controlId">
        <div class="lni-u-flex lni-u-flex-column">
            <x-input-text
                ref="address1"
                :data-control-id="controlId + '_address1'"
                :is-nested="true"
                :data-parent-id="controlId"
                :data-parent-short-name="shortName"
                data-label-text="Address:"
                data-short-name = "Address (line one)"
                :data-required="required"
                v-on:dataChanged="onDataChanged"
                v-on:errorChanged="onAddress1ErrorChanged"
            >
               <x-error v-if="errorText('address1')" :data-local-text="errorText('address1')" />
            </x-input-text>
            <x-input-text
                ref="address2"
                class="lni-u-pt0"
                :data-control-id="controlId + '_address2'"
                :is-nested="true"
                :data-parent-id="controlId"
                :data-parent-short-name="shortName"
                data-label-text="Address (line two):"
                data-short-name = "Address (line two)"
                v-on:dataChanged="onDataChanged"
                v-on:errorChanged="onAddress2ErrorChanged"
            >
                <x-error v-if="errorText('address2')" :data-local-text="errorText('address2')" />
            </x-input-text>
        </div>
        <div class="lni-o-grid--wrap">
            <x-input-text
                ref="city"
                class="lni-u-pt0"
                :data-control-id="controlId + '_city'"
                :is-nested="true"
                :data-parent-id="controlId"
                :data-parent-short-name="shortName"
                data-label-text="City:"
                data-short-name = "City"
                :data-required="required"
                v-on:dataChanged="onDataChanged"
                v-on:errorChanged="onCityErrorChanged"
            >
                <x-error v-if="errorText('city')" :data-local-text="errorText('city')" />
            </x-input-text>
            <x-select
                ref="state"
                :data-control-id="controlId + '_state'"
                :is-nested="true"
                :data-parent-id="controlId"
                :data-parent-short-name="shortName"
                data-label-text="State:"
                data-short-name = "State"
                :data-options="states"
                :data-required="required"
                class="lni-c-form-control--custom-width lni-u-pt0"
                maxlength="11"
                v-on:dataChanged="onDataChanged"
                v-on:errorChanged="onStateErrorChanged"
            >
                <x-error v-if="errorText('state')" :data-local-text="errorText('state')" />
            </x-select>
            <x-input-text
                ref="zipCode"
                :data-parent-id="controlId"
                :data-parent-short-name="shortName"
                :data-control-id="controlId + '_zipCode'"
                data-short-name="Zip Code"
                class="lni-c-form-control--custom-width lni-u-pt0"
                :is-nested="true"
                data-label-text="Zip code:"
                :data-required="required"
                @dataChanged="onDataChanged"
                @errorChanged="onZipCodeErrorChanged"
                placeholder="Up to 9 digits"
                maxlength="10"
                pattern="(\d{5}([\-]\d{4})?)"
                v-mask="{pattern: '#####-####', separator: '-'}"
            >
                <x-error v-if="errorText('zipCode')" :data-local-text="errorText('zipCode')" />
            </x-input-text>
        </div>
    </div>
</template>

<script>
import framework from '../../framework/instance';
import states from '../../../static/states.json';
import mask from '../directives/mask';

export default {
    name: 'x-input-address',
    mixins: [
        framework.mixins.abstractAggregateInput,
    ],
    directives: {
        mask,
    },
    data() {
        return {
            states,
        };
    },
    computed: {
        componentValue: {
            get() {
                return {
                    address1: this.$refs.address1.value,
                    address2: this.$refs.address2.value,
                    city: this.$refs.city.value,
                    state: this.$refs.state.value,
                    zipCode: this.$refs.zipCode.value,
                };
            },
            set(newValue) {
                const refs = this.$refs;
                refs.address1.value = newValue.address1;
                refs.address2.value = newValue.address2;
                refs.city.value = newValue.city;
                refs.state.value = newValue.state;
                refs.zipCode.value = refs.zipCode.$el.mask.formatString(newValue.zipCode);
            },
        },
    },
    mounted() {
        this.initialize();
    },
    methods: {
        /**
         * Adds the error from the child component to the errors of this component
         * @param {string} errorMessage The error message that the child component is passing.
         * @returns {void}
         */
        onAddress1ErrorChanged(errorMessage) {
            this.onErrorChanged('address1', errorMessage);
        },
        /**
         * Adds the error from the child component to the errors of this component
         * @param {string} errorMessage The error message that the child component is passing.
         * @returns {void}
         */
        onAddress2ErrorChanged(errorMessage) {
            this.onErrorChanged('address2', errorMessage);
        },
        /**
         * Adds the error from the child component to the errors of this component
         * @param {string} errorMessage The error message that the child component is passing.
         * @returns {void}
         */
        onCityErrorChanged(errorMessage) {
            this.onErrorChanged('city', errorMessage);
        },
        /**
         * Adds the error from the child component to the errors of this component
         * @param {string} errorMessage The error message that the child component is passing.
         * @returns {void}
         */
        onStateErrorChanged(errorMessage) {
            this.onErrorChanged('state', errorMessage);
        },
        /**
         * Adds the error from the child component to the errors of this component
         * @param {string} errorMessage The error message that the child component is passing.
         * @returns {void}
         */
        onZipCodeErrorChanged(errorMessage) {
            this.onErrorChanged('zipCode', errorMessage);
        },
    },
};

</script>



// WEBPACK FOOTER //
// source/components/x-input-address/x-input-address.vue